module.exports = __webpack_public_path__ + "img/nftBase.b25ac5d2.png";